var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolControlCentreFieldObs = function SvgFiremapSymbolControlCentreFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-symbol-control-centre-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    d: "M8.531 7.516c-2.604 0-4.524 1.812-4.524 4.26 0 2.484 1.884 4.332 4.44 4.332 1.272 0 2.652-.636 3.564-1.62l-1.44-1.536c-.576.588-1.356.972-2.004.972-1.14 0-2.004-.936-2.004-2.172 0-1.236.864-2.16 2.004-2.16.696 0 1.476.444 2.004 1.116l1.44-1.704c-.852-.912-2.208-1.488-3.48-1.488M16.688 7.516c-2.604 0-4.524 1.812-4.524 4.26 0 2.484 1.883 4.332 4.44 4.332 1.271 0 2.652-.636 3.564-1.62l-1.44-1.536c-.577.588-1.357.972-2.005.972-1.14 0-2.003-.936-2.003-2.172 0-1.236.864-2.16 2.004-2.16.695 0 1.476.444 2.003 1.116l1.44-1.704c-.852-.912-2.208-1.488-3.48-1.488"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-symbol-control-centre-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFiremapSymbolControlCentreFieldObs;